if (typeof Object.assign !== 'function') {
  (function () {
    Object.assign = function (target) {
      // We must check against these specific cases.
      if (target === undefined || target === null) {
        throw new TypeError('Cannot convert undefined or null to object');
      }

      const output = Object(target);

      for (let index = 1; index < arguments.length; index++) {
        const source = arguments[index];

        if (source !== undefined && source !== null) {
          for (const nextKey in source) {
            if (source.hasOwnProperty(nextKey)) {
              output[nextKey] = source[nextKey];
            }
          }
        }
      }

      return output;
    };
  })();
}

if (typeof Object.map !== 'function') {
  (() => {
    Object.map = iterator => {
      for (const key in this) {
        iterator(this[key], key);
      }
    };
  })();
}